import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../components/Logo";
import { apiPostJson } from "../lib/api";
import { toast } from "react-toastify";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const submit = async (event: React.FormEvent) => {
    event.preventDefault(); setSubmitting(true);
    try {
      const data = await apiPostJson<{ message: string }>("/api/auth/forgot-password", { email });
      setMessage(data.message);
      toast.success("Reset link sent. Check your inbox.");
    } catch (error: any) {
      toast.error(error?.message || "Unable to send reset link");
    } finally { setSubmitting(false); }
  };
  return <div className="auth-shell flex min-h-screen items-center justify-center px-6 py-12">
    <div className="auth-glow auth-glow-one" /><div className="auth-glow auth-glow-two" />
    <Link to="/" className="absolute left-6 top-6 z-10"><Logo className="text-xl text-slate-900" /></Link>
    <div className="auth-card relative z-10 w-full max-w-md p-8 sm:p-10">
      <p className="mb-3 text-xs font-bold uppercase tracking-[.18em] text-teal-700">Account recovery</p>
      <h1 className="font-display text-2xl font-semibold">Forgot your password?</h1>
      <p className="mt-2 text-sm leading-6 text-slate-500">Enter your account email. We’ll send a secure reset link valid for one hour.</p>
      {message ? <div className="mt-6 rounded-xl bg-teal-50 p-4 text-sm leading-6 text-teal-800">{message}</div> :
      <form className="mt-6 grid gap-4" onSubmit={submit}><label className="grid gap-1 text-sm font-medium text-slate-600">Email<input className="input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></label><button className="button" disabled={submitting}>{submitting ? "Sending…" : "Send reset link"}</button></form>}
      <Link to="/login" className="mt-5 inline-block text-sm font-semibold text-teal-700">← Back to login</Link>
    </div>
  </div>;
}
